import type { MinorUnitData } from '../types';

import minorUnit from './minorUnit.json' with { type: 'json' };

export const minorUnitData: MinorUnitData = minorUnit;
